// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EscapeRenderer__container-cc8748 {
  font-family: var(--escape-font-family);
}`, "",{"version":3,"sources":["webpack://./src/components/TextRenderer/renderTree/EscapeRenderer/EscapeRenderer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sCAAA;AACF","sourcesContent":[".container {\n  font-family: var(--escape-font-family);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EscapeRenderer__container-cc8748`
};
module.exports = ___CSS_LOADER_EXPORT___;
